import MUIAddIcon from '@mui/icons-material/Add';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const AddIcon = (props: SvgIconProps) => <MUIAddIcon {...props} />;
export default AddIcon;
